import CustomMessage from "../../../utils/CustomMessage";
import CustomToast from "../../../utils/CustomToast";
import * as TYPE from "../ActionConstants";
import ApiClient from "../../../apiClient";
import { BASE_URL, SEARCH, TRANSACTIONS } from "../../../constant/apiEndPoint";
import { checkSession } from "../auth/AuthActions";

export const loadingToggleAction = (dispatch, status) => {
  return dispatch({
    type: TYPE.IS_FETCHING,
    payload: status,
  });
};

export const getAllTransactionAction = (payload, navigate) => {
  return (dispatch) => {
    loadingToggleAction(dispatch, true);
    ApiClient.post(`${BASE_URL}${TRANSACTIONS.getAllTransactions}`, payload, true)
      .then((response) => {
        loadingToggleAction(dispatch, false);
        dispatch({
          type: TYPE.GET_ALL_TRANSACTION_SUCCESS,
          payload: response.data.result,
        });
      })
      .catch((error) => {
        if (error.status === 419) {
          CustomToast({
            type: "error",
            message: "Session expired, please login again",
            options: { autoClose: 5000, position: "top-center" },
          });
          checkSession(dispatch, navigate);
          return;
        }
        loadingToggleAction(dispatch, false);
        dispatch({
          type: TYPE.GET_ALL_TRANSACTION_FAIL,
          payload: CustomMessage(error.status),
        });
        CustomToast({
          type: "error",
          message: "Internal Server Error! Please try again later",
          options: { autoClose: 5000, position: "top-center" },
        });
      });
  };
};

export const getTransactionByIdAction = (tran_id, navigate) => {
  return (dispatch) => {
    loadingToggleAction(dispatch, true);
    ApiClient.get(`${BASE_URL}${TRANSACTIONS.getTransactionById}=${tran_id}`, {}, true)
      .then((response) => {
        loadingToggleAction(dispatch, false);
        dispatch({
          type: TYPE.GET_TRANSACTION_BY_ID_SUCCESS,
          payload: response.data.result.data,
        });
      })
      .catch((error) => {
        loadingToggleAction(dispatch, false);
        // if (error.status === 419) {
        //   CustomToast({
        //     type: "error",
        //     message: "Session expired, please login again",
        //     options: { autoClose: 5000, position: "top-center" },
        //   });
        //   checkSession(dispatch, navigate);
        //   return;
        // }
        dispatch({
          type: TYPE.GET_TRANSACTION_BY_ID_FAIL,
          payload: error.data.result.message,
        });
        CustomToast({
          type: "error",
          message: error?.data?.result?.message,
          options: { autoClose: 5000, position: "top-center" },
        });
      });
  };
};

export const getFilteredTransactionAction = (payload, navigate) => {
  return (dispatch) => {
    loadingToggleAction(dispatch, true);
    ApiClient.post(`${BASE_URL}${SEARCH.ADMIN_SEARCH}`, payload, true)
      .then((response) => {
        loadingToggleAction(dispatch, false);
        dispatch({
          type: TYPE.GET_ALL_TRANSACTION_SUCCESS,
          payload: response.data.result,
        });
      })
      .catch((error) => {
        loadingToggleAction(dispatch, false);
        dispatch({ type: TYPE.GET_ALL_TRANSACTION_FAIL, payload: [] });
        // if (error.status === 419) {
        //   CustomToast({
        //     type: "error",
        //     message: "Session expired, please login again",
        //     options: { autoClose: 5000, position: "top-center" },
        //   });
        //   checkSession(dispatch, navigate);
        //   return;
        // }
        CustomToast({
          type: "error",
          message: error?.data?.result?.message,
          options: { autoClose: 5000, position: "top-center" },
        });
      });
  };
};

export const getFilteredTransactionActionTransaction = (payload, navigate) => {
  return (dispatch) => {
    loadingToggleAction(dispatch, true);
    ApiClient.post(`${BASE_URL}${SEARCH.ADMIN_SEARCH_TRANSACTION}`, payload, true)
      .then((response) => {
        loadingToggleAction(dispatch, false);
        dispatch({
          type: TYPE.GET_ALL_TRANSACTION_SUCCESS,
          payload: response.data.result,
        });
      })
      .catch((error) => {
        loadingToggleAction(dispatch, false);
        dispatch({ type: TYPE.GET_ALL_TRANSACTION_FAIL, payload: [] });
        // if (error.status === 419) {
        //   CustomToast({
        //     type: "error",
        //     message: "Session expired, please login again",
        //     options: { autoClose: 5000, position: "top-center" },
        //   });
        //   checkSession(dispatch, navigate);
        //   return;
        // }
        CustomToast({
          type: "error",
          message: error?.data?.result?.message,
          options: { autoClose: 5000, position: "top-center" },
        });
      });
  };
};
